const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const CampaignManagementCommand: any = {
    SaveCampaign: `${Backofficebff}/v1/campaignmanagement/savecampaign`,
    UpdateStatus: `${Backofficebff}/v1/campaignmanagement/updatestatus`,
    InsertImage: `${Backofficebff}/v1/campaignmanagement/insertimage`,
    InsertImageMultiple: `${Backofficebff}/v1/campaignmanagement/insertimagemultiple`,
    CreateBadgeFolder: `${Backofficebff}/v1/campaignmanagement/createbadgefolder`,
    SaveUniqueCoupon: `${Backofficebff}/v1/campaignmanagement/saveUniqueCoupon`,
    SaveMultipleCoupon: `${Backofficebff}/v1/campaignmanagement/saveMultipleCoupon`,
    SaveMultipleCouponCustomer: `${Backofficebff}/v1/campaignmanagement/saveMultipleCouponCustomer`,
    SaveThirdPartyCoupon: `${Backofficebff}/v1/campaignmanagement/saveThirdPartyCoupon`,
    FileUpload: `${Backofficebff}/v1/campaignmanagement/fileUpload`,
    DownloadFile: `${Backofficebff}/v1/campaignmanagement/downloadFile`,
    DownloadFileFilter: `${Backofficebff}/v1/campaignmanagement/downloadFileFilter`,
    DownloadSlaveExcelFileFilter: `${Backofficebff}/v1/campaignmanagement/downloadSlaveExcelFileFilter`,
    SaveRule: `${Backofficebff}/v1/campaignmanagement/saveRule`,
    ReUpdateRuleProcessOrder: `${Backofficebff}/v1/campaignmanagement/reUpdateRuleProcessOrder`,
    SaveRuleCondition: `${Backofficebff}/v1/campaignmanagement/saveRuleCondition`,
    SaveRuleConditionFile: `${Backofficebff}/v1/campaignmanagement/saveRuleConditionFile`,
    SaveEarning: `${Backofficebff}/v1/campaignmanagement/saveEarning`,
    ReUpdateEarningProcessOrder: `${Backofficebff}/v1/campaignmanagement/reUpdateEarningProcessOrder`,
    SetRuleForEarning: `${Backofficebff}/v1/campaignmanagement/setRuleForEarning`,
    SaveMultipleCampaignFileFilter: `${Backofficebff}/v1/CampaignManagement/SaveMultipleCampaignFileFilter`,
    GenerateCampaignAIDescription: `${Backofficebff}/v1/campaignmanagement/GenerateCampaignAIDescription`,
};
